import { getCMSUrl } from './cms-urls';

const BUSCADOR = {
  classic: {
    mx: 'https://www.aeromexico.com/es-mx/buscar',
    us: 'https://www.aeromexico.com/es-mx/buscar',
    it: 'https://www.aeromexico.com/it-it/ricerca',
    jp: 'https://www.aeromexico.com/jp-jp/buscar',
    default: 'https://www.aeromexico.com/es-mx/buscar',
  },
};
const CHAT_URLS = {
  classic: {
    mx: 'https://chatventas.aeromexico.com/ChatClient/chatservlet?cliente=19',
    us: 'https://chat.aeromexico.com/aeromexicousach/clientesweb/aeromexicousa/default.aspx?language=ES&department=1022',
    default: 'https://chatventas.aeromexico.com/ChatClient/chatservlet?cliente=19',
  },
  messenger: {
    mx: '//m.me/AeromexicoMX',
    default: 'https://chatventas.aeromexico.com/ChatClient/chatservlet?cliente=19',
  },
};
const REGISTRO = {
  classic: {
    mx: 'https://pages.mx.aeromexico.com/RegistroNewsletter',
    us: 'https://pages.mx.aeromexico.com/RegistroNewsletter',
    default: 'https://pages.mx.aeromexico.com/RegistroNewsletter',
  },
};
const SOCIAL_URLS = {
  facebook: {
    mx: 'https://www.facebook.com/AeromexicoMX',
    us: 'https://www.facebook.com/AeromexicoNA',
  },
  instagram: 'https://instagram.com/aeromexico/',
  snapchat: 'https://www.snapchat.com/add/soyaeromexico',
  twitter: {
    mx: 'https://twitter.com/aeromexico',
    us: 'https://twitter.com/aeromexicousa',
  },
  linkedin: 'https://www.linkedin.com/company/18870/',
  youtube: 'https://www.youtube.com/user/AeromexicoTV',
};

const URLS = {
  accessibleSite: {
    mx: 'https://booking.aeromexico.com/SSW2010/D5EE/webqtrip.html?execution=e2s1',
    us: 'https://booking.aeromexico.com/SSW2010/D5DE/webqtrip.html',
    br: 'https://booking.aeromexico.com/SSW2010/D5EE/webqtrip.html?execution=e2s1',
    es: 'https://booking.aeromexico.com/SSW2010/D5EE/webqtrip.html?execution=e2s1',
    eu: 'https://booking.aeromexico.com/SSW2010/D5EE/webqtrip.html?execution=e2s1',
    nl: 'https://booking.aeromexico.com/SSW2010/D5EE/webqtrip.html?execution=e2s1',
    fr: 'https://booking.aeromexico.com/SSW2010/D5EE/webqtrip.html?execution=e2s1',
    // it
    it: 'https://booking.aeromexico.com/SSW2010/D5EE/webqtrip.html?execution=e2s1',
    jp: 'https://booking.aeromexico.com/SSW2010/D5EE/webqtrip.html?execution=e2s1',
  },
  bookGranplan: {
    default: 'https://www.aeromexicovacations.com/home/index.do',
    mx: {
      hotelAvion: 'https://www.granplan.com?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_package',
      hotel: 'https://www.granplan.com/hotel?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_hotel',
    },
    gt: {
      hotelAvion: 'https://www.granplan.com?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_package',
      hotel: 'https://www.granplan.com/hotel?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_hotel',
    },
    cr: {
      hotelAvion: 'https://www.granplan.com?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_package',
      hotel: 'https://www.granplan.com/hotel?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_hotel',
    },
    pe: {
      hotelAvion: 'https://www.granplan.com?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_package',
      hotel: 'https://www.granplan.com/hotel?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_hotel',
    },
    ec: {
      hotelAvion: 'https://www.granplan.com?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_package',
      hotel: 'https://www.granplan.com/hotel?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_hotel',
    },
    cl: {
      hotelAvion: 'https://www.granplan.com?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_package',
      hotel: 'https://www.granplan.com/hotel?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_hotel',
    },
    do: {
      hotelAvion: 'https://www.granplan.com?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_package',
      hotel: 'https://www.granplan.com/hotel?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_hotel',
    },
    hn: {
      hotelAvion: 'https://www.granplan.com?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_package',
      hotel: 'https://www.granplan.com/hotel?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_hotel',
    },
    pa: {
      hotelAvion: 'https://www.granplan.com?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_package',
      hotel: 'https://www.granplan.com/hotel?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_hotel',
    },
    ni: {
      hotelAvion: 'https://www.granplan.com?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_package',
      hotel: 'https://www.granplan.com/hotel?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_hotel',
    },
    sv: {
      hotelAvion: 'https://www.granplan.com?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_package',
      hotel: 'https://www.granplan.com/hotel?utm_source=Aeromexicocom&utm_medium=Aeromexicoweb&utm_campaign=Booker_hotel',
    },
  },
  clubPremier: {
    mx: 'https://www.clubpremier.com/mx/',
    us: 'https://www.clubpremier.com/us/',
    fr: 'https://www.clubpremier.com/fr/',
    pt: 'https://www.clubpremier.com/pt/',
    // it
    it: 'https://www.clubpremier.com/it/',
    jp: 'https://www.clubpremier.com/jp/',

  },
  clubPremierProfile: {
    mx: 'https://reservaciones.clubpremier.com/travel/arc.cfm?utm_source=am&utm_medium=profile&utm_campaign=reserva',
    us: 'https://reservaciones.clubpremier.com/travel/arc.cfm?utm_source=am&utm_medium=profile&utm_campaign=reserva',
    // fr: 'https://www.clubpremier.com/fr/',
  },
  clubPremierMember: {
    // mx: 'https://member.clubpremier.info/j_spring_security_check?url=&admin=false&j_username=&j_password=&corporate=0&j_ssotoken=',
    mx: 'https://reservaciones.clubpremier.com/profiles/club_premier_loyalty_process.cfm?tab=a&ssoToken=',
    us: 'https://reservaciones.clubpremier.com/profiles/club_premier_loyalty_process.cfm?tab=a&ssoToken=',
  },
  contactClubPremier: {
    mx: 'https://www.clubpremier.com/mx/bienvenido/?code=modalContact?utm_source=Aeromexico&utm_medium=modal_contacto&utm_campaign=menu_am_com',
    us: 'https://www.clubpremier.com/us/welcome/?utm_source=Aeromexico&utm_medium=home_cp&utm_campaign=menu_am_com',
  },
  granplan: 'https://www.granplan.com/',
  home: 'https://aeromexico.com/',
  jobs: {
    mx: 'https://erpexternop.aeromexico.com.mx/OA_HTML/RF.jsp?function_id=14296&resp_id=23350&resp_appl_id=800&security_group_id=0&lang_code=ESA&params=zcTNT0D8XRO2DqsgtATaRU.dXleRxhQ6U8q0Sp5ViENeAd4foiCwPNDHT2Od8vyaqn5SOJmqXL1mru2zaGmHbICP5nLn1xFjfte3Bp.JX952fobKvSL2-E01O3MDik85&oas=MQMuLzo0gMiDYJxelsgYhg..',
    us: 'https://world.aeromexico.com/en/about-us/aeromexico-corporate/international-job-offers/?site=us',
    fr: 'https://world.aeromexico.com/fr/a-propos-de-nous/aeromexico-corporatif/offres-d-emploi-internationales/?site=fr',
    // it
    it: 'https://world.aeromexico.com/it/chi-siamo/aeromexico-corporate/international-job-offers/?site=it',
    jp: 'https://world.aeromexico.com/jp/about-us/aeromexico-corporate/international-job-offers/?site=jp',

  },
  manageYourTrip: {
    ar: 'https://www.aeromexico.com/es-ar/administra-tu-viaje',
    ca: 'https://www.aeromexico.com/en-ca/manage-your-booking',
    eu: 'https://www.aeromexico.com/en-eu/manage-your-booking',
    fr: 'https://www.aeromexico.com/fr-fr/gerez-votre-reservation',
    mx: 'https://www.aeromexico.com/es-mx/administra-tu-viaje',
    nl: 'https://aeromexico.com/en-us/manage-your-booking',
    pt: 'https://www.aeromexico.com/pt-br/gerenciar-seus-voos',
    us: 'https://www.aeromexico.com/en-us/manage-your-booking',
    it: 'https://www.aeromexico.com/it-it/gestisci-viaggio',
    jp: 'https://www.aeromexico.com/jp-jp/manage-your-booking',
  },
  manageYourTripHeaderMenu: {
    es: {
      ar: 'https://aeromexico.com/es-ar/administra-tu-viaje',
      mx: 'https://aeromexico.com/es-mx/administra-tu-viaje',
      es: 'https://aeromexico.com/es-es/administra-tu-viaje',
      do: 'https://aeromexico.com/es-do/administra-tu-viaje',
      ho: 'https://aeromexico.com/es-ho/administra-tu-viaje',
      sv: 'https://aeromexico.com/es-sv/administra-tu-viaje',
      pe: 'https://aeromexico.com/es-pe/administra-tu-viaje',
      pa: 'https://aeromexico.com/es-pa/administra-tu-viaje',
      ni: 'https://aeromexico.com/es-ni/administra-tu-viaje',
      us: 'https://aeromexico.com/es-us/administra-tu-viaje',
      cl: 'https://aeromexico.com/es-cl/administra-tu-viaje',
      ec: 'https://aeromexico.com/es-ec/administra-tu-viaje',
      cr: 'https://aeromexico.com/es-cr/administra-tu-viaje',
      gt: 'https://aeromexico.com/es-gt/administra-tu-viaje',
    },
    en: {
      us: 'https://aeromexico.com/en-us/manage-your-booking',
      nl: 'https://aeromexico.com/en-us/manage-your-booking',
    },
    fr: {
      fr: 'https://aeromexico.com/fr-fr/gerez-votre-reservation',
    },
    // it
    it: {
      it: 'https://aeromexico.com/it-it/gestisci-viaggio',
    },
    jp: {
      jp: 'https://aeromexico.com/jp-jp/manage-your-booking',
    },
    pt: {
      br: 'https://aeromexico.com/pt-br/gerenciar-seus-voos',
    },
  },
  myTrips: {
    mx: 'https://aeromexico.com/es/personaliza-tu-viaje/?site=mx',
    us: 'https://aeromexico.com/en/manage-your-trip/?site=us',
    br: 'https://aeromexico.com/pt-br/gerenciar-seus-voos',
  },
  redress: 'https://www.dhs.gov/redress-control-numbers',
  report: {
    mx: 'https://www.tipsanonimos.com/aeromexico/',
    us: 'https://www.tipsanonimos.com/aeromexico/index.aspx?Lan=en-us',
  },
  routes: 'https://flights.aeromexico.com',
  ticketOffices: 'https://world.aeromexico.com/es/contactanos/oficinas-de-boletos/index.html',
  TSAPreCheck: 'https://www.tsa.gov/tsa-precheck',
  vacations: {
    mx: getCMSUrl('mx', 'es', 'VACATIONS'),
    us: 'https://www.aeromexicovacations.com/?opt=gp',
    gt: getCMSUrl('gt', 'es', 'VACATIONS'),
    cr: getCMSUrl('cr', 'es', 'VACATIONS'),
    pe: getCMSUrl('pe', 'es', 'VACATIONS'),
    ec: getCMSUrl('ec', 'es', 'VACATIONS'),
    cl: getCMSUrl('cl', 'es', 'VACATIONS'),
    do: getCMSUrl('do', 'es', 'VACATIONS'),
    hn: getCMSUrl('hn', 'es', 'VACATIONS'),
    pa: getCMSUrl('pa', 'es', 'VACATIONS'),
    ni: getCMSUrl('ni', 'es', 'VACATIONS'),
    sv: getCMSUrl('sv', 'es', 'VACATIONS'),
  },
};

const MANAGE_BOOKING_URLS = {
  ar: {
    es: 'https://www.aeromexico.com/es-ar/administra-tu-viaje/',
  },
  us: {
    en: 'https://aeromexico.com/en-us/manage-your-booking',
    es: 'https://aeromexico.com/es-us/administra-tu-viaje',
  },
  mx: {
    en: 'https://aeromexico.com/es-us/administra-tu-viaje',
    es: 'https://aeromexico.com/es-mx/administra-tu-viaje',
  },
  ca: {
    en: 'https://www.aeromexico.com/en-ca/manage-your-booking',
    fr: 'https://www.aeromexico.com/fr-ca/gerez-votre-reservation',
  },
  cl: {
    es: 'https://www.aeromexico.com/es-cl/administra-tu-viaje/',
  },
  cr: {
    es: 'https://www.aeromexico.com/es-cr/administra-tu-viaje/',
  },
  ec: {
    es: 'https://www.aeromexico.com/es-ec/administra-tu-viaje/',
  },
  sv: {
    es: 'https://www.aeromexico.com/es-sv/administra-tu-viaje/',
  },
  hn: {
    es: 'https://www.aeromexico.com/es-hn/administra-tu-viaje/',
  },
  gt: {
    es: 'https://www.aeromexico.com/es-gt/administra-tu-viaje/',
  },
  ni: {
    es: 'https://www.aeromexico.com/es-ni/administra-tu-viaje/',
  },
  pa: {
    es: 'https://www.aeromexico.com/es-pa/administra-tu-viaje/',
  },
  do: {
    es: 'https://www.aeromexico.com/es-do/administra-tu-viaje/',
  },
  pe: {
    es: 'https://www.aeromexico.com/es-pe/administra-tu-viaje/',
  },
  es: {
    es: 'https://www.aeromexico.com/es-es/administra-tu-viaje/',
  },
  eu: {
    en: 'https://www.aeromexico.com/en-eu/manage-your-booking/',
  },
  fr: {
    fr: 'https://www.aeromexico.com/fr-fr/gerez-votre-reservation/',
  },
  gb: {
    en: 'https://www.aeromexico.com/en-gb/manage-your-booking/',
  },
  nl: {
    en: 'https://www.aeromexico.com/en-nl/manage-your-booking/',
  },
  it: {
    it: 'https://www.aeromexico.com/it-it/gestisci-viaggio',
  },
  jp: {
    jp: 'https://www.aeromexico.com/jp-jp/manage-your-booking',
  },
};

const BOOKER_GRANPLAN_URLS = {
  cars: 'https://reservaciones.granplan.com/Autos/Lista?',
  hotels: 'https://reservaciones.granplan.com/Hoteles/Lista?',
  hotelsTarifa: 'https://reservaciones.granplan.com/Hoteles/Tarifas?',
  vacations: 'https://reservaciones.granplan.com/Paquetes/Lista?',
};

const BOOKER_AM_VACATIONS_URL = 'https://www.aeromexicovacations.com/booking/index.do?';

const BOOKER_HERTZ_URL = 'https://autos.aeromexico.com/';
const BOOKER_HERTZ_URL_DEEP_LINK = 'https://aeromexico-v2-dev.carrentalgateway.com/';

const BOOKER_MULTI_CITY_URL = {
  mx: 'https://booking.aeromexico.com/SSW2010/D5EE/webqtrip.html?',
  us: 'https://booking.aeromexico.com/SSW2010/D5DE/webqtrip.html?',
};

const CONTACT_US_FORMS = {
  'contact-us-customer-service': 'https://www.vuela.aeromexico.com/forms/formAtencionClientes.php',
  'contact-us-investor-relations': 'https://www.vuela.aeromexico.com/forms/formInvestors.php',
  'contact-us-aeromexico-vacations': 'https://www.vuela.aeromexico.com/forms/formGranPlan.php',
  'contact-us-aeromexico-vacations-group': 'https://www.vuela.aeromexico.com/forms/formGrupos.php',
  'contact-us-aeromexico-customer-service': 'https://vuela.aeromexico.com/forms/contacto/index.html?language=',
};

const REFUND_URL = 'https://reembolsosweb.aeromexico.com/reembolsos/?_ga=2.129373320.545801313.1715189353-1020462947.1712554329';

export {
  BOOKER_AM_VACATIONS_URL,
  BOOKER_GRANPLAN_URLS,
  BOOKER_HERTZ_URL,
  BOOKER_HERTZ_URL_DEEP_LINK,
  BOOKER_MULTI_CITY_URL,
  BUSCADOR,
  CHAT_URLS,
  CONTACT_US_FORMS,
  MANAGE_BOOKING_URLS,
  REFUND_URL,
  REGISTRO,
  SOCIAL_URLS,
  URLS,
};
